import React from 'react';

import styles from './styles.css';
export default ({ title, description }: any) => (
  <div className={styles.wrap}>
    <span className={styles.title}>{title}</span>
    <span
      className={styles.description}
      dangerouslySetInnerHTML={{
        __html: description,
      }}
    />
  </div>
);
